import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Phone, Radio, Wifi, Users, Shield, ShieldCheck, Bug, Laptop, ArrowRight } from "lucide-react";
const solutions = [
  {
    icon: Phone,
    key: "skydial",
    color: "text-textBlue",
    bgColor: "bg-blueLight",
  },
  {
    icon: Radio,
    key: "voiceapi",
    color: "text-secondaryOrange",
    bgColor: "bg-orange-50",
  },
  {
    icon: Users,
    key: "aicounting",
    color: "text-purple-600",
    bgColor: "bg-purple-50",
  },
  {
    icon: Shield,
    key: "vms",
    color: "text-emerald-600",
    bgColor: "bg-emerald-50",
  },
  {
    icon: ShieldCheck,
    key: "soc",
    color: "text-red-600",
    bgColor: "bg-red-50",
  },
  {
    icon: Bug,
    key: "vapt",
    color: "text-amber-600",
    bgColor: "bg-amber-50",
  },
  {
    icon: Laptop,
    key: "firstprotect",
    color: "text-indigo-600",
    bgColor: "bg-indigo-50",
  },
  {
    icon: Wifi,
    key: "networking",
    color: "text-textBlueDark",
    bgColor: "bg-backgroundTeal",
  },
];

const SolutionsSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 px-6 md:px-16 sm:px-4 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block bg-textBlue text-white text-md px-6 py-2 rounded-full mb-4">
            {t("solutions.label")}
          </span>
          <h2 className="text-4xl md:text-3xl sm:text-2xl font-bold text-gray-800">
            {t("solutions.title")}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-1 gap-8">
          {solutions.map((solution, index) => {
            const Icon = solution.icon;
            const isSkydial = solution.key === "skydial";

            return (
              <div
                key={index}
                className="bg-white p-8 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className={`${solution.bgColor} w-16 h-16 rounded-full flex items-center justify-center mb-4`}>
                  {isSkydial ? (
                    <img
                      src="/logo skydial.svg"
                      alt="Skydial"
                      className="w-10 h-10 object-contain"
                    />
                  ) : (
                    <Icon className={`w-8 h-8 ${solution.color}`} />
                  )}
                </div>
                <h3 className="text-2xl font-semibold text-gray-800 mb-3">
                  {t(`solutions.${solution.key}.title`)}
                </h3>
                <p className="text-gray-600 mb-4">
                  {t(`solutions.${solution.key}.description`)}
                </p>
                {isSkydial ? (
                  <Link
                    to={`/solutions/${solution.key}`}
                    className="inline-flex items-center gap-2 text-textBlue hover:text-textBlueDark font-semibold transition-colors"
                  >
                    {t("solutions.viewMore")}
                    <ArrowRight className="w-4 h-4" />
                  </Link>
                ) : (
                  <Link
                    to={`/solutions/${solution.key}`}
                    className="inline-flex items-center gap-2 text-textBlue hover:text-textBlueDark font-semibold transition-colors"
                  >
                    {t("solutions.viewMore")}
                    <ArrowRight className="w-4 h-4" />
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
